import * as React from "react";
const SvgFiBrandsLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-line_svg__a)">
      <path d="M18.59 0H5.41A5.41 5.41 0 0 0 0 5.41v13.18A5.41 5.41 0 0 0 5.41 24h13.18A5.41 5.41 0 0 0 24 18.59V5.41A5.41 5.41 0 0 0 18.59 0m-.306 14.865c-1.679 1.932-5.432 4.286-6.286 4.646s-.728-.229-.693-.432c.021-.12.114-.685.114-.685.027-.204.055-.521-.026-.723-.09-.223-.444-.338-.705-.395-3.845-.508-6.692-3.196-6.692-6.406 0-3.58 3.59-6.494 8.002-6.494S20 7.289 20 10.87c-.001 1.432-.556 2.723-1.716 3.995" />
      <path d="M15.81 10.012v.59h1.528c.084 0 .153.068.153.152v.568a.153.153 0 0 1-.153.153H15.81v.59h1.528c.084 0 .153.068.153.152v.568a.15.15 0 0 1-.153.152H15.09a.153.153 0 0 1-.153-.152V9.292c0-.084.068-.153.153-.153h2.248c.084 0 .153.068.153.153v.567a.153.153 0 0 1-.153.153zM9.174 12.217v.568a.15.15 0 0 1-.153.152H6.773a.15.15 0 0 1-.152-.152V9.292c0-.084.068-.153.152-.153h.568c.084 0 .153.068.153.153v2.772h1.528c.084 0 .152.07.152.153M10.528 9.292v3.492a.15.15 0 0 1-.153.152h-.567a.153.153 0 0 1-.153-.152V9.292c0-.084.068-.153.153-.153h.567c.084 0 .153.07.153.153M14.391 9.292v3.492a.15.15 0 0 1-.153.152h-.564a.16.16 0 0 1-.128-.066l-1.6-2.16v2.074a.15.15 0 0 1-.153.152h-.568a.153.153 0 0 1-.153-.152V9.292c0-.084.068-.153.153-.153h.564c.053 0 .099.028.13.07l1.598 2.157V9.292c0-.084.068-.153.153-.153h.568c.085 0 .153.07.153.153" />
    </g>
    <defs>
      <clipPath id="fi-brands-line_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsLine;
